import {Pipe, PipeTransform} from '@angular/core';

import {SettingsTilesService} from "../core";
import {TilesContainer} from "../models";

@Pipe({
    name: 'orderByObject'
})
export class OrderByObjectPipe implements PipeTransform {
    constructor(
        private settingsTiles: SettingsTilesService,
    ) {
    }

    transform(items: TilesContainer[]): TilesContainer[] {
        if (!Array.isArray(items)) return [];

        const filtered = [];

        items.forEach(item => {
            filtered.push(item);
        });

        filtered.sort(this.settingsTiles.sortByContainerOrder);

        return filtered;
    }
}
